skrilla.controller('pickemsContestsCtrl', function ($scope, cacheService, searchService, adminService, modalService, $location) {

  $scope.userId = $location.search().userId || null;
  $scope.hasRole = adminService.hasRole;
  $scope.pageKey = "contests";
  $scope.contests = cacheService.getObjectOrElse("contests", []);
  $scope.selectedContests = [];

  $scope.clicked = function (contest) {
    if (contest.selected === false || contest.selected === undefined) {
      $scope.selectedContests.push(contest);
    } else {
      $scope.selectedContests = $scope.selectedContests.filter(function (_contest) {
        return _contest.id !== contest.id
      });
    }
    cacheService.registerObject("selectedPickemsContests", $scope.selectedContests);
  }

  $scope.action = function () {
    modalService.openModal('/views/pickems/contests/createContestMarketsModal.html', true, 'lg', false, false);
  }

  $scope.publishAll = function () {
    modalService.confirm("Are you sure you'd like to publish these contests?", function () {
      searchService.post("pickems/contests/publishAll", {}, "Contests Successfully Published!").then(function (response) {
      });
    });
  };
});

